import React, { useContext } from 'react'
import { bigPadding, getAssetLink, liveHeaderHeight } from '../common/utils'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import { ParamsContext } from '../qualityMonitoring/qualityMonitoring'
import { getReturnPath } from '../qualityAnalysis/analysisUtils'
import { breadCrumbHeight } from '../qualityMonitoring/breadCrumb'

export function GoBackBar(): JSX.Element {
    const urlParams = useContext(ParamsContext).split('/')

    return (
        <StyledGoBackBar className={'goBackBar'}>
            <a className={'goBackBar--link area-header-back'} href={getAssetLink(getReturnPath(urlParams))}>
                <i className="icon-area-header-back"></i>
                {i18n('Back')}
            </a>
        </StyledGoBackBar>
    )
}

const StyledGoBackBar = styled.div`
    width: 100%;
    height: 60px;
    min-height: 60px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: ${({ theme }) => theme['gray-200']};
    font-size: 18px;
    padding: 0 ${() => bigPadding}px;
    position: sticky;
    top: ${breadCrumbHeight + liveHeaderHeight}px;
    left: 0;
    z-index: 2;

    .goBackBar {
        &--link {
            color: ${({ theme }) => theme['gray-800']};
            display: flex;
            align-items: center;
            &:hover {
                text-decoration: none;
            }
            i {
                color: ${({ theme }) => theme['blue-500']};
                margin: 0;
                margin-right: 10px;
            }
        }
    }
`
